angular.module('shared').factory('WorkoutService', ["UnitSymbols", function(UnitSymbols) {
  var WorkoutService;
  WorkoutService = {
    getPersonalBest: function(ex) {
      var getTimeOrDistance, getWeightAndReps, td, weight;
      if (!ex) {
        return;
      }
      getWeightAndReps = function() {
        var reps, weight;
        if (!(ex.reps || ex.weight)) {
          return null;
        }
        reps = ex.reps ? `${ex.reps} Reps` : void 0;
        weight = ex.weight ? `${parseFloat(ex.weight)}${UnitSymbols[ex.weight_unit] || ''}` : void 0;
        return _.compact([reps, weight]).join(' ');
      };
      getTimeOrDistance = function() {
        var distance, time, timePresence;
        timePresence = ex.hours || ex.minutes || ex.seconds;
        if (!(ex.distance_number || timePresence)) {
          return;
        }
        time = moment().startOf('day').hours(ex.hours || 0).minutes(ex.minutes || 0).seconds(ex.seconds || 0).format('HH:mm:ss');
        distance = ex.distance_number ? `${ex.distance_number}${UnitSymbols[ex.distance_unit]}` : void 0;
        return _.compact([distance, time]).join('/');
      };
      switch (ex.exercise_type) {
        case 'weight_and_reps':
          return getWeightAndReps();
        case 'reps':
          return ex.reps;
        case 'time_or_distance':
          return getTimeOrDistance();
        case 'weight_reps_time_distance':
          weight = getWeightAndReps();
          td = getTimeOrDistance();
          return _.compact([weight, td]).join(' ');
      }
    }
  };
  return WorkoutService;
}]);
